module.exports = __webpack_public_path__ + "static/media/hr_practitioners-02.5259d52e.png";